import { inject, injectable } from "inversify";
import { Logger } from "@designboticteam/core";
import { CursorSnappingService } from "../../../../input/CursorSnappingService";
import { Workspace3DStoreService } from "../../../../services/Workspace3DStoreService";
import { SceneService } from "../../../../stage/SceneService";
import { LineSegment } from "../../../entities/LineSegment";
import { ShapeEditingService } from "../../../services/ShapeEditingService";
import { PolylineTool } from "../PolylineTool/PolylineTool";

@injectable()
class LineSegmentTool extends PolylineTool {
	public static readonly toolName: string = "LineSegmentTool";
	public override readonly toolName: string = LineSegmentTool.toolName;
	protected override readonly logger = new Logger(`🔁 ${this.toolName}`, {
		color: "#ffffff",
		backgroundColor: "#0e7490",
	});

	constructor(
		@inject(SceneService) sceneService: SceneService,
		@inject(CursorSnappingService) cursorSnappingService: CursorSnappingService,
		@inject(ShapeEditingService) shapeEditingService: ShapeEditingService,
		@inject(Workspace3DStoreService) workspace3DStoreService: Workspace3DStoreService,
	) {
		super(shapeEditingService, sceneService, cursorSnappingService, workspace3DStoreService);
	}

	protected override createShape() {
		return new LineSegment({ label: "LineSegment" });
	}
}

export { LineSegmentTool };
